var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAhrFilledIconOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.59 6.50289C29.1641 6.19826 28.701 5.94937 28.2119 5.76226C27.3178 5.45299 26.3715 5.32319 25.4272 5.3803C24.4829 5.43741 23.5591 5.68031 22.7088 6.09507L22.5447 6.17007L5.53378 13.9279C5.4438 13.9697 5.34438 13.9869 5.24559 13.9778C5.1468 13.9688 5.05217 13.9338 4.97128 13.8763L1.95253 11.6919C1.79264 11.5767 1.6021 11.5116 1.40511 11.5049C1.20813 11.4982 1.01361 11.5503 0.846282 11.6544L0.199407 12.0576C0.110078 12.1122 0.0445794 12.1985 0.015922 12.2993C-0.0127355 12.4 -0.00245565 12.5078 0.0447198 12.6013L2.44003 16.9748C2.44003 16.9748 4.52128 20.6826 15.2885 14.8044L13.4932 24.6482L15.4666 23.8373L21.2978 12.1513C21.2978 12.1513 26.5666 9.86851 29.6041 7.80601C29.7236 7.7435 29.8235 7.64916 29.8928 7.53341C29.962 7.41765 29.9979 7.28501 29.9964 7.15014C29.995 7.01527 29.9562 6.88343 29.8845 6.7692C29.8128 6.65497 29.7109 6.5628 29.59 6.50289ZM23.4353 6.82164C24.0583 6.51359 24.7363 6.33219 25.4298 6.28793C26.1234 6.24368 26.8189 6.33745 27.476 6.56382C27.476 6.56382 24.8791 8.49976 23.4353 6.82164Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3531 10.5227L16.2375 8.30078H16.2328L7.1625 5.62891L5.625 6.56172L11.3484 10.5227H11.3531Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhrFilledIconOne);
export default __webpack_public_path__ + "static/media/ahr-filled-icon-one.02c6442bc20c01f22af1b93de90c4b0d.svg";
export { ForwardRef as ReactComponent };